export const getValueOrDash = (val) => {
  if (val) {
    return val;
  } else return "-";
};

export const getStringFromList = (listOfString) => {
  if (typeof listOfString === "object") {
    let stringOf = "";
    listOfString.forEach((item) => {
      if (listOfString.length - 1 === listOfString.indexOf(item)) {
        stringOf += item;
      } else {
        stringOf += item + ", ";
      }
    });
    return stringOf;
  }
  return listOfString;
};

export const invoiceHandler = (invoiceList) => {
  let resultString = ""
  invoiceList.forEach((item) => {
    if (invoiceList.length - 1 === invoiceList.indexOf(item)) {
      resultString += item.PartNo;
    } else {
      resultString += item.PartNo + ", ";
    }
  })
  return resultString
}